module.exports = __webpack_public_path__ + "img/ИФ-1(А)-009-m.04a1ffc8.png";